/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {AbortPreviousSessionRunsRequest} from "../model/abort-previous-session-runs-request";
import {AddScenarioRecordingGroupRequest} from "../model/add-scenario-recording-group-request";
import {CreateDraftTrainingSessionRequest} from "../model/create-draft-training-session-request";
import {DraftTrainingSessionResponse} from "../model/draft-training-session-response";
import {FinalizeDraftTrainingSessionRequest} from "../model/finalize-draft-training-session-request";
import {GetTrainingSessionByIdsRequest} from "../model/get-training-session-by-ids-request";
import {ISimSession} from "../model/i-sim-session";
import {RemoveScenarioRecordingGroupRequest} from "../model/remove-scenario-recording-group-request";
import {SearchTrainingSessionsRequest} from "../model/search-training-sessions-request";
import {SetDraftTrainingSessionScenarioRequest} from "../model/set-draft-training-session-scenario-request";
import {TeamTrainingSession} from "../model/team-training-session";

@Injectable({
    providedIn: "root",
})
export class SimTrainingSessionService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
    public abortPreviousSessionRuns(request: AbortPreviousSessionRunsRequest) {
        return super.post<string[]>(`/api/TrainingSession/AbortPreviousSessionRuns`, request);
    }
/**
 * @deprecated Dont use for anything, only here for legacy reasons, session-selection-stepper adhoc session - to be refactored.
 */ 

    public addScenarioRecordingGroup(request: AddScenarioRecordingGroupRequest) {
        return super.post<DraftTrainingSessionResponse>(`/api/TrainingSession/AddScenarioRecordingGroup`, request);
    }
/**
 * @deprecated Dont use for anything, only here for legacy reasons, session-selection-stepper adhoc session - to be refactored.
 */ 

    public createDraftTrainingSession(request: CreateDraftTrainingSessionRequest) {
        return super.post<DraftTrainingSessionResponse>(`/api/TrainingSession/CreateDraftTrainingSession`, request);
    }
/**
 * @deprecated Dont use for anything, only here for legacy reasons, session-selection-stepper adhoc session - to be refactored.
 */ 

    public finalizeDraftTrainingSession(request: FinalizeDraftTrainingSessionRequest) {
        return super.post<DraftTrainingSessionResponse>(`/api/TrainingSession/FinalizeDraftTrainingSession`, request);
    }
/**
 * Use POST, because url can get very long.
 */ 

    public getTrainingSessionByIds(request: GetTrainingSessionByIdsRequest) {
        return super.post<ISimSession[]>(`/api/TrainingSession/GetTrainingSessionByIds`, request);
    }

    public hasPreviousSessionRunsToBeAborted(trainingSessionId: string, sessionRunIndex: number) {
        return super.get<boolean>(`/api/TrainingSession/HasPreviousSessionRunsToBeAborted`, {trainingSessionId: trainingSessionId, sessionRunIndex: sessionRunIndex});
    }
/**
 * @deprecated Dont use for anything, only here for legacy reasons, session-selection-stepper adhoc session - to be refactored.
 */ 

    public removeScenarioRecordingGroup(request: RemoveScenarioRecordingGroupRequest) {
        return super.post<DraftTrainingSessionResponse>(`/api/TrainingSession/RemoveScenarioRecordingGroup`, request);
    }

    public searchTrainingSessions(request: SearchTrainingSessionsRequest) {
        return super.post<ISimSession[]>(`/api/TrainingSession/SearchTrainingSessions`, request);
    }
/**
 * @deprecated Dont use for anything, only here for legacy reasons, session-selection-stepper adhoc session - to be refactored.
 */ 

    public setDraftTrainingSessionScenario(request: SetDraftTrainingSessionScenarioRequest) {
        return super.post<DraftTrainingSessionResponse>(`/api/TrainingSession/SetDraftTrainingSessionScenario`, request);
    }

    public validateOccupiedRooms(request: TeamTrainingSession) {
        return super.post<string[]>(`/api/TrainingSession/ValidateOccupiedRooms`, request);
    }

    public validateOccupiedUsers(request: TeamTrainingSession) {
        return super.post<string[]>(`/api/TrainingSession/ValidateOccupiedUsers`, request);
    }
}